import { PaymentProviderDto } from '@tiendanube/common';

export const HookUtils = {
  getProviderId: (paymentProvider?: PaymentProviderDto) => {
    if (!paymentProvider)
      throw new Error("no providerAppId was found in the HookUtils' getAppId");
    return paymentProvider.id;
  },
};
